// Runtime config derived from build-time env. The deploy target is baked in
// at build time so the right adapter ships in each artifact.

const target = (typeof __DEPLOY_TARGET__ !== "undefined" && __DEPLOY_TARGET__) ||
  import.meta.env.VITE_DEPLOY_TARGET ||
  "digitalocean";

const siteMode = (import.meta.env.VITE_SITE_MODE || "b2b").toLowerCase();

export const config = {
  deployTarget: target,
  isEmbedded: target === "embedded",
  siteMode, // "public" | "b2b" | "dual"
  publicSiteUrl: import.meta.env.VITE_PUBLIC_SITE_URL || "",
  b2bSiteUrl: import.meta.env.VITE_B2B_SITE_URL || "",
  apiBase: import.meta.env.VITE_API_BASE || "/api",
  netsuite: {
    account: import.meta.env.VITE_NETSUITE_ACCOUNT || "",
    realm: import.meta.env.VITE_NETSUITE_REALM || "",
    restletBase: import.meta.env.VITE_NETSUITE_RESTLET_BASE || "",
  },
  oidc: {
    authority: import.meta.env.VITE_OIDC_AUTHORITY || "",
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID || "",
    redirectUri: import.meta.env.VITE_OIDC_REDIRECT_URI ||
      (typeof window !== "undefined" ? `${window.location.origin}/auth/callback` : ""),
    postLogoutRedirectUri: import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI ||
      (typeof window !== "undefined" ? window.location.origin : ""),
    scope: import.meta.env.VITE_OIDC_SCOPE || "openid profile email restlets rest_webservices",
  },
  bolt: {
    publishableKey: import.meta.env.VITE_BOLT_PUBLISHABLE_KEY || "",
    divisionId: import.meta.env.VITE_BOLT_DIVISION_ID || "",
  },
  // Payment gateway routing. `id` selects which adapter mounts in
  // PaymentOverlay; `captureMode` is the default when the order policy
  // doesn't override it.
  payments: {
    gateway: (import.meta.env.VITE_PAYMENT_GATEWAY || "bolt").toLowerCase(),
    captureMode: (import.meta.env.VITE_PAYMENT_CAPTURE_MODE || "auth_capture").toLowerCase(),
    // "auth_only"     — place a hold; capture later (typical for B2B
    //                   when fulfilment lags the order).
    // "auth_capture"  — charge immediately on order placement.
  },
  klaviyo: {
    siteId: import.meta.env.VITE_KLAVIYO_SITE_ID || "",
  },
  ga: {
    measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || "",
  },
};
